import React, {Component} from 'react';
import './index.scss';
import * as messageConstants from '../../../shared/messages';

class NewIdpCertificatePanel extends Component {

    handleShowModalIdpMetadata = () => {
        this.props.showIdpMetadataPopup();
    }
    handleShowModalStartUsingNewIdpCertificate = () => {
        this.props.showStartUsingNewIdpCertificatePopup();
    }

    render() {
        return(
            <div className="new-idp-certificate-panel">
                <div className="info-mark"/>
                <div className="new-idp-certificate-panel-message">
                    <div className="new-idp-certificate-header">{messageConstants.NEW_IDP_CERTIFICATE_PANEL_HEADER}</div>
                    <div className="new-idp-certificate-text">{messageConstants.RECONFIGURE_SBA_WITH_UPDATED_IDP_METADATA}</div>
                    <a role="button"
                        id="showModalIdpMetadataButton"
                        className="btn btn-link new-idp-certificate-link-button"
                        onClick={this.handleShowModalIdpMetadata}>
                        {this.props.newIdpMetadataButtonText}
                    </a>
                    <div className="new-idp-certificate-text">{messageConstants.START_USING_NEW_IDP_CERTIFICATE_TITLE}</div>
                    <a role="button"
                        id="startUsingNewIdpCertificatebutton"
                        className="btn btn-link new-idp-certificate-link-button"
                        onClick={this.handleShowModalStartUsingNewIdpCertificate}>
                        {messageConstants.START_USING_NEW_IDP_CERTIFICATE_BUTTON}
                    </a>
                </div>
            </div>
        )
    }
}

export default NewIdpCertificatePanel;